"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Container = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../../utils");
var _ui = require("../../ui");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  height: 316px;\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiary;
}, _utils.mediaQuery.lessThan('sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: 263px;\n  "]))));
exports.Wrapper = Wrapper;
var Container = function Container(props) {
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: "mt-auto ".concat(props.className)
  }, /*#__PURE__*/_react.default.createElement(_ui.Container, {
    className: "h-100"
  }, props.children));
};
exports.Container = Container;